import { JSX, ReactNode } from "react";
import { distributeIntoColumns } from "../../../../utils/productDetail/distributeIntoColumns";

interface Props {
    items: ReactNode[];
    columnCount: number;
}

export const ProductDetailColumnGrid = ({
    items,
    columnCount,
}: Props): JSX.Element => {
    const columns = distributeIntoColumns(items, columnCount);

    return (
        <div className="c-product-specs">
            <div className="c-product-specs__container c-product-specs__container--columns">
                {columns.map((columnItems, columnIndex) => (
                    <div className="c-product-specs__column" key={columnIndex}>
                        {columnItems}
                    </div>
                ))}
            </div>
            <div className="c-product-specs__container c-product-specs__container--stacked">
                {items}
            </div>
        </div>
    );
};
